import React from 'react';
import FJSearchMatch from '../view/FJSearchMatch.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FJActionTextBasedEditing from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';

const FJSearchMatchContainer = () => {
    const dispatch = useDispatch();
    const currentMathIndex = useSelector(state => state.textBasedEditing.currentMatchIndex);
    const matchIndexList = useSelector(state => state.textBasedEditing.matchIndexList);
    const searchText = useSelector(state => state.textBasedEditing.searchText);
    const _onSearch = value => {
        dispatch(FJActionTextBasedEditing.onSearchAction(value));
    };
    const _onNext = () => {
        dispatch(FJActionTextBasedEditing.nextMatchAction());
    };
    const _onPrevious = () => {
        dispatch(FJActionTextBasedEditing.previousMatchAction());
    };

    return (
        <FJSearchMatch
            searchText={searchText}
            onSearch={_onSearch}
            currentMathIndex={currentMathIndex}
            matchIndexList={matchIndexList}
            onPrevious={_onPrevious}
            onNext={_onNext}
        />
    );
};

export default FJSearchMatchContainer;
